import React, { useEffect, useState } from "react";
import { Card, Form, Button } from "react-bootstrap";

const Question = ({
  questionIdx,
  totalQuestions,
  questionText,
  options,
  selections,
  isMultipleChoice,
  saveSelection,
  readonly,
  label,
  className,
  ...props
}) => {
  const [selectedOptions, setSelectedOptions] = useState(
    isMultipleChoice ? [] : ""
  );

  useEffect(() => {
    if (selections !== null) setSelectedOptions(selections);
  }, []);

  const handleRadioChange = (option) => {
    setSelectedOptions(option);
  };

  const handleCheckboxChange = (option) => {
    setSelectedOptions((prev) =>
      prev.includes(option)
        ? prev.filter((v) => v !== option)
        : [...prev, option]
    );
  };

  return (
    <Card className={`p-4 shadow-lg mt-2 mb-2 ${className}`}>
      <Card.Body>
        <Card.Subtitle className="mb-2 text-muted">
          <div className="d-flex justify-content-between mb-2 text-muted">
            <span>
              Question {questionIdx + 1} out of {totalQuestions}
            </span>
            <span>{label}</span>
          </div>
        </Card.Subtitle>
        <Card.Title>{questionText}</Card.Title>
        <Form>
          {options.map((choice, index) => (
            <Form.Check
              key={index}
              type={isMultipleChoice ? "checkbox" : "radio"}
              name="question"
              value={index}
              label={choice}
              disabled={readonly}
              checked={
                isMultipleChoice
                  ? selectedOptions.includes(index)
                  : selectedOptions === index
              }
              onChange={() => {
                if (!readonly) {
                  if (isMultipleChoice) handleCheckboxChange(index);
                  else handleRadioChange(index);
                  saveSelection(questionIdx, index);
                }
              }}
            />
          ))}
        </Form>
      </Card.Body>
    </Card>
  );
};

export default Question;
